export default __webpack_public_path__ + "static/media/damage5.5357ee3b.png";